module.exports = __webpack_public_path__ + "static/media/connectBankAccount.6156aa3d.png";